import { queryTests } from '@/features/tests/data';
import { buildMetricsDateRange } from '@/shared/utils/metricsRange';
import type { TestInclude } from '../data/tests';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { QueryResult, TestListItemDto } from '@flowqa/shared';

export const fetchTestsGrid = async (
  projectId?: string | null,
  organisationId?: string | null,
  input?: GridQueryInput,
  includeOverride?: TestInclude,
  includeDeltas = true,
): Promise<QueryResult<TestListItemDto>> => {
  const resolvedInput = input ?? { page: 1, pageSize: 50, sorts: [], filters: [] };
  const metricsRange = buildMetricsDateRange();
  const include: TestInclude = includeOverride ?? {
    suites: { ids: true, items: true, primary: true },
    latestExecution: true,
    executionStatusCounts: true,
    executionSummaries: true,
    metrics: true,
    metricDeltas: includeDeltas,
  };
  return await queryTests(projectId ?? undefined, organisationId ?? undefined, {
    ...resolvedInput,
    ...metricsRange,
    include,
  });
};
